module.exports = __webpack_public_path__ + "static/media/editPencil.a3492d21.svg";